import { ref, computed } from "vue";
import { useDisplay } from "vuetify";
import type { Ref } from "vue";

/**
 * 画面表示に関わる UI 状態を管理する composable。
 *
 * @returns 画面で利用するリアクティブな状態オブジェクト
 */
export const useScheduledDeliveryUiState = (params: {
  shopSelectFromValues: Ref<{ shop_code: string; name: string }>;
  shopSelectToValues: Ref<{ shop_code: string; name: string }>;
}) => {
  /* 画面状態 */
  const mode = ref<"regist" | "list">("regist");

  const panel = ref<number[]>([0]);

  //Loading
  const overlay = ref<boolean>(false);

  //ダイアログ初期化
  const confirmDeleteDialog = ref<boolean>(false);

  const tab = ref<string>("tab1");

  // Vuetify breakpoint
  const { xs } = useDisplay();
  const isXs = computed(() => xs.value);

  /**
   * 店舗間定期配達登録設定タブ @Click
   */
  const onClickRegistTab = async (): Promise<void> => {
    mode.value = "regist";
    tab.value = "tab1";
    params.shopSelectFromValues.value = { shop_code: "", name: "" };
    params.shopSelectToValues.value = { shop_code: "", name: "" };
  };

  /**
   * 店舗間定期配達一覧タブ @Click
   */
  const onClickListTab = async (): Promise<void> => {
    mode.value = "list";
    tab.value = "tab2";
    params.shopSelectFromValues.value = { shop_code: "", name: "" };
    params.shopSelectToValues.value = { shop_code: "", name: "" };
  };

  return {
    mode,
    panel,
    overlay,
    confirmDeleteDialog,
    tab,
    isXs,
    onClickRegistTab,
    onClickListTab,
  };
};
